export const BlockPartner = ( block: HTMLElement ) => {
	const PartnerBlockObject = {
		container: block,
		items: block.querySelectorAll( '.partner-column' ) as NodeListOf<HTMLElement>,
		filterButtons: block.querySelectorAll( '.tag-filter__button' ) as NodeListOf<HTMLButtonElement>,
		moreButton: block.querySelector( '.button--more' ) as HTMLElement|null,
		activeFocus: null as string|null,
		isExpanded: false,
		visibleItemLimit: 4,

		_init(): void {
			this._bindClass();
			this._bindEvents();
			this._initActiveFilter();
			this.updateItems();
		},

		_bindClass(): void {
			this.filterPartners = this.filterPartners.bind( this );
			this.showMore       = this.showMore.bind( this );
		},

		_bindEvents(): void {
			this.filterButtons.forEach( ( button: HTMLButtonElement ) => {
				button.addEventListener( 'click', this.filterPartners );
			} );

			this.moreButton?.addEventListener( 'click', this.showMore );
		},

		_initActiveFilter(): void {
			const activeButton = Array.from( this.filterButtons ).find( ( button: HTMLButtonElement ) => {
				return button.closest( '.tag-filter' )?.classList.contains( 'tag-filter--active' );
			} ) ?? this.filterButtons[0] ?? null;

			this.activeFocus = activeButton?.dataset.filterFocus ?? null;
			this.setActiveFilter( activeButton );
		},

		filterPartners( event: Event ): void {
			event.preventDefault();

			const button = event.currentTarget as HTMLButtonElement;

			this.activeFocus = button.dataset.filterFocus ?? null;
			this.isExpanded  = true;
			this.setActiveFilter( button );
			this.updateItems();
		},

		setActiveFilter( activeButton: HTMLButtonElement|null ): void {
			this.filterButtons.forEach( ( button: HTMLButtonElement ) => {
				const isActive = button === activeButton;

				button.closest( '.tag-filter' )?.classList.toggle( 'tag-filter--active', isActive );
				button.setAttribute( 'aria-pressed', isActive ? 'true' : 'false' );
			} );
		},

		updateItems(): void {
			let matchingItemIndex = 0;

			this.items.forEach( ( item: HTMLElement ) => {
				const matchesFocus = !this.activeFocus || item.dataset.focus === this.activeFocus;
				const isWithinLimit = this.isExpanded || matchingItemIndex < this.visibleItemLimit;
				const isVisible = matchesFocus && isWithinLimit;

				item.style.display = isVisible ? '' : 'none';

				if ( matchesFocus ) {
					matchingItemIndex++;
				}
			} );

			if ( this.moreButton ) {
				const showMoreButton = !this.activeFocus
					&& !this.isExpanded
					&& matchingItemIndex > this.visibleItemLimit;

				this.moreButton.style.display = showMoreButton ? '' : 'none';
			}
		},

		showMore( event: Event ): void {
			event.preventDefault();

			this.isExpanded = true;
			this.updateItems();
		},
	};

	PartnerBlockObject._init();
	return PartnerBlockObject;
};
